import axios from 'axios';

/**
 * @param {string} accountName
 * @param {string} token
 * @returns {Promise<object[]>}
 */
export const getUserTemplates = (accountName, token) => {
    const url = `https://${accountName}.fabtale.com/api/v2/user/templates`;

    return axios({
        url: url,
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(res => res.data);
};

export async function updateAccountPreferences(newData) {
	const shopDomain = new URLSearchParams(window.location.search).get('shop');

	try {
		const url = `${process.env.REACT_APP_API_URI}/${process.env.REACT_APP_PIPELINE_STAGE}/account${global.location.search}`;

		return await axios.patch(url, {
			data: {
				shopDomain,
				...newData
			}
		});
	} catch (e) {
		console.error('updating account preferences failed');
	}
}

export const getUserPreferences = async (queryParams) => {
    return axios.get(
    	`${process.env.REACT_APP_API_URI}/${process.env.REACT_APP_PIPELINE_STAGE}/account${queryParams}`
	).then(res => res.data);
};


// WEBPACK FOOTER //
// ./src/api/index.js